import { BrowserUtils, StringUtils } from '../utils/siteUtils'
import { useEffect } from 'react'
import { LandingPageNumber, VehiclePageNumber, SummaryPageNumber } from '../constants'

export default (landingContext, updateGlobalState) => {
  const { vinResults, urlState } = landingContext
  const hasOptions = urlState && !!urlState.o
  const shouldNavigate = getShouldNavigate({ vinResults, urlState })

  useEffect(() => {
    const vin = vinResults && vinResults.vin
    if (vin && vinResults) {
      const shouldNavigate = getShouldNavigate({ vinResults, urlState })
      const { ymmObject, stateObject } = processVinResults(vinResults, hasOptions)
      const { updateState } = ymmObject
      shouldNavigate && BrowserUtils.navigateWithLastUrlState(ymmObject, stateObject)

      const fireTag = updateState.p ? { fireAnalytics: 'continue_timbuybkhome_selltrade', fromLanding: false } : {}
      const globalStateUpdate = { ...fireTag, activeTab: 'VIN', vin: undefined, plate: undefined, state: undefined }
      updateGlobalState(globalStateUpdate)
    }
  }, [vinResults, updateGlobalState, hasOptions, shouldNavigate])
}

const getShouldNavigate = ({ vinResults, urlState }) =>
  urlState?.p === LandingPageNumber || (urlState?.p === SummaryPageNumber && vinResults?.vin !== urlState?.vin) || (urlState?.p === VehiclePageNumber && urlState?.pa?.includes('reviewoffer') && vinResults?.vin !== urlState?.vin)
const processVinResults = (vinResults, hasOptions) => {
  const { year, make, model, trim, engines, colors, drivetrains, transmissions, options, vin } = vinResults
  if (year && make && model) {
    const updateState = { vin }
    if (trim) {
      updateState.s = trim.trimId
    }
    if (engines && engines.length === 1) updateState.e = engines[0].engineId
    if (colors && colors.length === 1) updateState.c = colors[0].colorId
    if (drivetrains && drivetrains.length === 1) updateState.d = drivetrains[0].drivetrainId
    if (transmissions && transmissions.length === 1) updateState.t = transmissions[0].transmissionId
    if (options && options.length && !hasOptions) {
      const changedOptions = []
      options.forEach(option => {
        if (option.isSelected !== option.isDefault) changedOptions.push(StringUtils.toUrlDisplayName(option.displayName) + (option.isSelected ? '1' : '0'))
      })
      updateState.o = changedOptions
    }
    const ymmObject = { year, make, model, updateState }
    const stateObject = { year, make, model, trim }
    return { ymmObject, stateObject }
  }
  return {}
}
